/* import __COLOCATED_TEMPLATE__ from './lightguide.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();